import { IconSaveSvg } from '../../assets/icons/svgComponents'
import Button from '../button'
import Checkbox from '../checkbox'
import Form from '../form'

import * as S from './styles'
type Props = {
  data: any
  handleClick: () => void
  active: boolean
  setActive: () => void
}
const CreateTest = ({ data, handleClick, active, setActive }: Props) => {
  return (
    <S.Wrapper>
      <S.Body>
        <S.CreateTitle>
          Cadastro de testes
          <Button
            initialIcon={<IconSaveSvg />}
            className="button-save"
            onClick={handleClick}
          >
            Salvar
          </Button>
        </S.CreateTitle>
        <Checkbox
          label="Ativo"
          wrapperClassName="active-checkbox"
          isChecked={active}
          onClick={setActive}
        />
        <S.InputsContainer>
          <Form data={data} />
        </S.InputsContainer>
      </S.Body>
    </S.Wrapper>
  )
}
export default CreateTest
